// extracted by mini-css-extract-plugin
export default {"floating":"floating-0c880"};